import { render } from "./AdminEditWinnner.vue?vue&type=template&id=409c35ec"
import script from "./AdminEditWinnner.vue?vue&type=script&lang=js"
export * from "./AdminEditWinnner.vue?vue&type=script&lang=js"
script.render = render

export default script